export default "__VITE_ASSET__016f4b9b__"